import repairshop_fi from '@src/translations/fi/repairshop.json'
import i18next from 'i18next'

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: 'fi', // language to use
  resources: {
    fi: {
      repairshop: repairshop_fi,
    },
  },
})

export default i18next
